export default __webpack_public_path__ + "static/1184-a929942523503aa684896e667804f9a7.gif";